import type { Post } from '@/@types/post'
import { formatAsRelativeTime } from '@/utils/day'
import { Box } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import Avatar from '../Avatar'
import ScreenNames from '../ScreenNames'
import PostHeader from './PostHeader'
import UserCard from './PostTargetCard/UserCard'
import styles from './UserFollowPost.module.css'

export interface UserFollowPostProps extends HTMLAttributes<HTMLDivElement> {
	data: Post | undefined
}

export default function UserFollowPost({ data, className, ...props }: UserFollowPostProps) {
	const users = data?.users
	const user = users?.[0]
	const targetUser = data?.targetUsers?.[0]

	if (!data || !users || !user || !targetUser) {
		return null
	}
	const { createdAt } = data

	return (
		<div className={clsx(styles.container, className)} {...props}>
			<Box>
				<Avatar data={user} className={styles.avatar} />
			</Box>

			<div className={styles.content}>
				<PostHeader
					title={
						<div className={styles.title}>
							<ScreenNames data={users} />
							<span className={styles.secondaryText}>关注了即友</span>
						</div>
					}
					desc={formatAsRelativeTime(createdAt)}
				/>
				<div className={styles.userCard}>
					<Link
						to="/u/$username"
						params={{
							username: targetUser.username,
						}}
						data-clickable-feedback
					>
						<UserCard data={targetUser} />
					</Link>
				</div>
			</div>
		</div>
	)
}
